import DOMPurify from "dompurify";
import React from "react";

import { AppCard, AppCardContent } from "./Generic/AppCard";

interface Props {
  htmlText: string;
}

const RequiredDocFreeText = (props: Props) => {
  return (
    <AppCard className="RequiredDocFreeText">
      <AppCardContent>
        <div
          className="ScheduledVisitDocScreen__freeText"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.htmlText) }}
        />
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocFreeText);
